import { BarChart3 } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { GetAnalyticsNodeData } from '@repo/shared-types';

export const GetAnalyticsNode = ({
  data,
  selected,
}: {
  data: GetAnalyticsNodeData;
  selected?: boolean;
}) => {
  const subtitle = [
    data.channel && data.channel !== 'ALL' ? data.channel : null,
    data.mode === 'contacts' ? 'by contact' : null,
    data.outputKey ? `→ ${data.outputKey}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <NodeShell
      type="get_analytics"
      icon={<BarChart3 size={16} />}
      label={data.label}
      subtitle={subtitle || undefined}
      selected={selected}
    />
  );
};
